import { useMutation } from'@tanstack/react-query';
import {disconnectApis } from'./api';
import { CreateDisconnectionRequestPayload, DisconnectRequestPayload } from'./types';
import { useNavigate } from 'react-router-dom';
import { useSmartMutation } from '@shared/api/queries/hooks';

export const useCreateDisconnectionRequest = () => {
  return useSmartMutation(
    (payload: CreateDisconnectionRequestPayload) =>
      disconnectApis.createDisconnectionRequest(payload),
  );
};